import qualityEventsHelpers from '../quality-events.helpers';

export const AI_LABELLING_POPUP_QUALITY_EVENTS = {
    viewed(authorId: User['id'], world: User['world']) {
        return qualityEventsHelpers.track({
            type: 'ai_labelling_popup_viewed',
            extra: JSON.stringify({ author_id: authorId, world })
        });
    },
    dismissedCta(authorId: User['id'], world: User['world']) {
        return qualityEventsHelpers.track({
            type: 'ai_labelling_popup_dismissed_cta',
            extra: JSON.stringify({ author_id: authorId, world })
        });
    },
    dismissedClose(authorId: User['id'], world: User['world']) {
        return qualityEventsHelpers.track({
            type: 'ai_labelling_popup_dismissed_close',
            extra: JSON.stringify({ author_id: authorId, world })
        });
    }
};
